/**
 * Defer non-critical work so buyer interactions stay responsive (M17).
 * @param {() => void} callback
 */
export function scheduleNonBlocking(callback) {
  if (typeof callback !== "function") return;

  try {
    if (typeof queueMicrotask === "function") {
      queueMicrotask(callback);
      return;
    }
  } catch {
    // fall through
  }

  setTimeout(callback, 0);
}
